import React from "react";
import PropTypes from "prop-types";
import InnerHTML from "dangerously-set-html-content";

const P2PInjection = ({ injectionData = "" }) =>
    injectionData ? <InnerHTML html={injectionData} /> : null;

P2PInjection.propTypes = {
    injectionData: PropTypes.string,
};

export default P2PInjection;
